import {createRouter,createWebHistory} from 'vue-router'

const routes = [
    {
        path: "/", name: 'index',
        // redirect: "/three-3d-map",
        meta: {name: '首页'},
        component: () => import("@/pages/index/homePage.vue"),
    },
]
const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
